import { useNavigate } from 'react-router-dom';

interface SuccessMessageProps {
  className?: string;
}

export function SuccessMessage({ className = '' }: SuccessMessageProps) {
  const navigate = useNavigate();

  return (
    <div className={`text-center ${className}`}>
      <div className="mb-8">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-[32px] font-bold text-[#222222] mb-6">회원가입 완료!</h1>
        
        <div className="space-y-3 mb-8">
          <p className="text-[20px] text-[#606060]">
            에코딜에 오신 것을 환영합니다.
          </p>
          <p className="text-[20px] text-[#606060]">
            지금 바로 할인 상품을 둘러보고 단골 매장을 찾아보세요.
          </p>
        </div>
        
        <button
          onClick={() => navigate('/')}
          className="w-full max-w-md h-[60px] bg-[#51C854] text-white font-semibold text-[20px] rounded-xl hover:bg-[#46B649] transition-colors mx-auto block"
        >
          홈페이지로 이동
        </button>
      </div>
    </div>
  );
}
